import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/influencer/new',
  title: 'title',
  endpoint: '/app/person',
}
